var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "59px",
    viewBox: "0 0 52 59",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 16\u5907\u4EFD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M16,0 C24.836556,0 32,7.18018102 32,16.0373832 C32,20.8685844 29.8687274,25.2008371 26.4971752,28.1410666 L16.0250448,39 L5.52692836,28.1620446 C2.1414336,25.221464 0,20.8800872 0,16.0373832 C0,7.18018102 7.163444,0 16,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-53.1%",
    y: "-33.3%",
    width: "206.2%",
    height: "187.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-40.6%",
    y: "-40.6%",
    width: "181.2%",
    height: "181.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u65B0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2,
    transform: "translate(-781.000000, -713.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-16\\u5907\\u4EFD",
    transform: "translate(791.000000, 719.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5F62\\u72B6\\u7ED3\\u5408\\u5907\\u4EFD"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#32C5FF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u6444\\u50CF\\u5934",
    filter: "url(#filter-3)",
    transform: "translate(8.000000, 8.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-24",
    transform: "translate(1.000000, 0.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.91067194,5.46613966 C8.43214756,4.98761528 7.87351779,4.75783926 7.21370224,4.75783926 C6.55388669,4.75783926 5.99525692,4.98761528 5.51673254,5.46613966 C5.03820817,5.92779974 4.80843215,6.48642951 4.80843215,7.14624506 C4.80843215,7.80606061 5.03820817,8.36469038 5.51673254,8.82635046 C5.99314888,9.28801054 6.55388669,9.51778656 7.21370224,9.51778656 C7.87351779,9.51778656 8.43214756,9.28801054 8.91067194,8.82635046 C9.38919631,8.36469038 9.61897233,7.80606061 9.61897233,7.14624506 C9.61897233,6.48642951 9.38708827,5.92779974 8.91067194,5.46613966 L8.91067194,5.46613966 Z M8.91067194,5.46613966 C8.43214756,4.98761528 7.87351779,4.75783926 7.21370224,4.75783926 C6.55388669,4.75783926 5.99525692,4.98761528 5.51673254,5.46613966 C5.03820817,5.92779974 4.80843215,6.48642951 4.80843215,7.14624506 C4.80843215,7.80606061 5.03820817,8.36469038 5.51673254,8.82635046 C5.99314888,9.28801054 6.55388669,9.51778656 7.21370224,9.51778656 C7.87351779,9.51778656 8.43214756,9.28801054 8.91067194,8.82635046 C9.38919631,8.36469038 9.61897233,7.80606061 9.61897233,7.14624506 C9.61897233,6.48642951 9.38708827,5.92779974 8.91067194,5.46613966 L8.91067194,5.46613966 Z M8.91067194,5.46613966 C8.43214756,4.98761528 7.87351779,4.75783926 7.21370224,4.75783926 C6.55388669,4.75783926 5.99525692,4.98761528 5.51673254,5.46613966 C5.03820817,5.92779974 4.80843215,6.48642951 4.80843215,7.14624506 C4.80843215,7.80606061 5.03820817,8.36469038 5.51673254,8.82635046 C5.99314888,9.28801054 6.55388669,9.51778656 7.21370224,9.51778656 C7.87351779,9.51778656 8.43214756,9.28801054 8.91067194,8.82635046 C9.38919631,8.36469038 9.61897233,7.80606061 9.61897233,7.14624506 C9.61897233,6.48642951 9.38708827,5.92779974 8.91067194,5.46613966 L8.91067194,5.46613966 Z",
    id: "\\u5F62\\u72B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4555995,10.7362319 C14.0985507,9.63372859 14.4274045,8.44690382 14.4274045,7.14624506 C14.4274045,5.8455863 14.0985507,4.65876153 13.4555995,3.55625823 C12.8126482,2.4516469 11.9230567,1.59578393 10.8205534,0.954940711 C9.71594203,0.31198946 8.514361,0 7.21370224,0 C5.91304348,0 4.69459816,0.31198946 3.58998682,0.954940711 C2.48748353,1.59789196 1.61264822,2.45375494 0.971805007,3.55625823 C0.328853755,4.65876153 0,5.8455863 0,7.14624506 C0,8.44690382 0.328853755,9.63372859 0.971805007,10.7362319 C1.5030303,11.6490119 2.19235837,12.3931489 3.0397892,12.9855072 C1.99631094,13.3059289 1.35335968,13.7444005 1.35335968,14.229249 C1.35335968,15.2073781 3.97786561,16 7.21370224,16 C10.4495389,16 13.0740448,15.2073781 13.0740448,14.229249 C13.0740448,13.7422925 12.4268775,13.3038208 11.3770751,12.9833992 C12.226614,12.3910408 12.9243742,11.6490119 13.4555995,10.7362319 Z M4.4627141,4.42898551 C5.21949934,3.67220026 6.1428195,3.29275362 7.21370224,3.29275362 C8.28458498,3.29275362 9.2057971,3.67220026 9.96469038,4.42898551 C10.7214756,5.17101449 11.1009223,6.07536232 11.1009223,7.14624506 C11.1009223,8.2171278 10.7214756,9.12358366 9.96469038,9.86350461 C9.20790514,10.6055336 8.28458498,10.9828722 7.21370224,10.9828722 C6.1428195,10.9828722 5.22160738,10.6034256 4.4627141,9.86350461 C3.70592885,9.12147563 3.32648221,8.2171278 3.32648221,7.14624506 C3.32648221,6.07747036 3.70592885,5.17101449 4.4627141,4.42898551 Z",
    id: "\\u5F62\\u72B6"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCamera);
export default __webpack_public_path__ + "static/media/icon_camera.fb1cdfc9a7f4e29be2a5dff1e911096c.svg";
export { ForwardRef as ReactComponent };